import { onPath } from '../utils/path';
import Glide from '@glidejs/glide';
import { selectOne, addClass } from '../utils/dom-utils';

onPath('/landing-pages/*', () => {
  const email = selectOne("#username");
  const password = selectOne("#password");

  const signupFormOnPage = (email && password);

  if(signupFormOnPage) {
    email.addEventListener("blur", function (event) {
      addClass(email, "touched");
    });
    password.addEventListener("blur", function (event) {
      addClass(password, "touched");
    });
    password.addEventListener("keydown", function (event) {
      addClass(password, "touched");
    });
    email.addEventListener("keydown", function (event) {
      addClass(email, "touched");
    });


    email.addEventListener("input", function (event) {
      if (email.validity.typeMismatch || email.validity.valueMissing) {
        email.setCustomValidity("Fill me in with your e-mail address!");
      } else {
        email.setCustomValidity("");
      }
    });

    password.addEventListener("input", function (event) {
      if (password.validity.tooShort || password.validity.valueMissing) {
        password.setCustomValidity("Fill me in with a password at least 5 charactes long!");
      } else {
        password.setCustomValidity("");
      }
    });
  }

});